/* istanbul ignore file */
import React from 'react';
import { LinkField, useFieldHelper } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { useContactUrl } from 'domain/sales/contact/contactRouting';

const ContactLinkField = ({
  idSource = undefined,
  idValue = '',
  linkText: initialLinkText = undefined,
  isInternal = true,
  ...props
}: any) => {
  const { getSingleEntityUrl } = useContactUrl();
  const { getValue: getId } = useFieldHelper({ source: idSource, value: idValue });
  const { data } = useShowContext();
  const linkText = typeof initialLinkText === 'function' ? initialLinkText(data) : initialLinkText;
  const id = getId();

  return <LinkField {...props} isInternal={isInternal} linkText={linkText} value={id && getSingleEntityUrl(id)} />;
};

export default ContactLinkField;
